import React from 'react';
import { theme } from '../../styles/theme';
import Header from '../common/Header';

const HIRA = ({ user, setUser }) => {
  return (
    <div className="min-h-screen bg-white">
      <Header 
        user={user} 
        setUser={setUser}
        title="HIRA Tool"
      />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center space-x-6 mb-8">
            <img 
              src="/assets/sms-prime/hira-logo.svg" 
              alt="HIRA Tool" 
              className="w-16 h-16"
            />
            <div>
              <h1 
                className="text-3xl font-bold mb-2" 
                style={{ color: theme.colors.text.primary }}
              >
                Hazard Identification & Risk Assessment
              </h1>
              <p 
                className="text-xl" 
                style={{ color: theme.colors.text.secondary }}
              >
                Streamlining Hazard Identification and Risk Assessment for Enhanced Safety and Decision-Making
              </p>
            </div>
          </div>

          <div 
            className="bg-white rounded-xl shadow-lg p-8 border"
            style={{ borderColor: theme.colors.border.light }}
          >
            <div className="text-center py-12">
              <h2 
                className="text-2xl font-semibold mb-4"
                style={{ color: theme.colors.text.primary }}
              >
                Welcome to HIRA Tool
              </h2>
              <p 
                className="text-lg max-w-2xl mx-auto"
                style={{ color: theme.colors.text.secondary }}
              >
                The HIRA Tool is being configured. Soon you'll be able to:
              </p>
              <ul className="mt-6 space-y-3 text-left max-w-md mx-auto">
                <li className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Identify and document potential hazards</span>
                </li>
                <li className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Assess risks using standardized matrices</span>
                </li>
                <li className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Implement and track mitigation measures</span>
                </li>
                <li className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Generate comprehensive safety reports</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HIRA;
